import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lock'
})
export class LockPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/pipe/lock.pipe.ts